import { ActionReducerMap, MetaReducer } from '@ngrx/store';
import { environment } from '../../../environments/environment';

/**
 * storeFreeze prevents state from being mutated. When mutation occurs, an
 * exception will be thrown. This is useful during development mode to
 * ensure that none of the reducers accidentally mutates the state.
 */
import { storeFreeze } from 'ngrx-store-freeze';
import { LocationsFeatureState } from '../locations';
import { routerReducer, RouterReducerState } from '@ngrx/router-store';
import { RouterState } from './router.serializer';
import { flushStore } from './meta-reducers';
import { coreStateReducer } from './core-reducer';
import { CoreState } from './core-state';
import { UsersFeatureState } from '../../components/users/state/users-state';
import { ReviewFeatureState } from '../../components/reviews/state/review.state';
import { AiInsightsFeatureState } from '../../components/ai-insights/state/ai-insights-state';
import { CampaignFeatureState } from '../../components/campaigns/state/campaign.state';
import { ReviewInsightsFeatureState } from '../../components/review-insights/state/insights-state';

export interface GlobalState {
  router: RouterReducerState<RouterState>,
  locations?: LocationsFeatureState, // feature state initialized lazily
  users?: UsersFeatureState, // feature state initialized lazily
  review?: ReviewFeatureState, // feature state initialized lazily
  reviewInsights?: ReviewInsightsFeatureState, // feature state initialized lazily
  aiInsights?: AiInsightsFeatureState, // feature state initialized lazily
  campaign?: CampaignFeatureState, // feature state initialized lazily
  core: CoreState
}

/**
 * Throw an error in DEV mode on any attempt to mutate store state
 */
export const metaReducers: MetaReducer<GlobalState>[] = environment.production ? [flushStore] : [flushStore, storeFreeze];

export const reducers: ActionReducerMap<GlobalState> = {
  router: routerReducer,
  // other shared state reducers
  core: coreStateReducer,
};
